import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.types';
import { TargetTemplateFormSection } from '../TargetDeliveryTemplateAccessFunction.types';

let nextId = 1;

// eslint-disable-next-line import/prefer-default-export
export function createTargetDeliveryTemplateBasedOnTemplate(
  template?: FormTemplate,
  forceInterfaceCreation = false,
): Partial<types.TargetDeliveryTemplateAccessFunctionFormData> {
  if (template == null) {
    return {};
  }

  const collectionFunctionForm: Partial<types.TargetDeliveryTemplateAccessFunctionFormData> = {
    ...getFieldValuesFromSection(template.main as FormTemplateSection),
    EIMSGENERAL: getInterfaceFieldValuesFromSection(
      template.EIMSGENERAL as FormTemplateSection,
      template,
      'EIMSGENERAL',
      forceInterfaceCreation,
    ),
    EIMSWRLNTRGT: getInterfaceFieldValuesFromSection(
      template.EIMSWRLNTRGT as FormTemplateSection,
      template,
      'EIMSWRLNTRGT',
      forceInterfaceCreation,
    ),
    EIMSTARGET: getInterfaceFieldValuesFromSection(
      template.EIMSTARGET as FormTemplateSection,
      template,
      'EIMSTARGET',
      forceInterfaceCreation,
    ),
    EIMSMCNB: getInterfaceFieldValuesFromSection(
      template.EIMSMCNB as FormTemplateSection,
      template,
      'EIMSMCNB',
      forceInterfaceCreation,
    ),
    EIMSMSCTRGT: getInterfaceFieldValuesFromSection(
      template.EIMSMSCTRGT as FormTemplateSection,
      template,
      'EIMSMSCTRGT',
      forceInterfaceCreation,
    ),
    EIMSGPRSTRGT: getInterfaceFieldValuesFromSection(
      template.EIMSGPRSTRGT as FormTemplateSection,
      template,
      'EIMSGPRSTRGT',
      forceInterfaceCreation,
    ),
    EIMSMC: getInterfaceFieldValuesFromSection(
      template.EIMSMC as FormTemplateSection,
      template,
      'EIMSMC',
      forceInterfaceCreation,
    ),
    targetInformation: getInterfaceFieldValuesFromSection(
      template.targetInformation as FormTemplateSection,
      template,
      'targetInformation',
      forceInterfaceCreation,
    ),
    callContentChannels: getInterfaceFieldValuesFromSection(
      template.callContentChannels as FormTemplateSection,
      template,
      'callContentChannels',
      forceInterfaceCreation,
    ),
    monitoringCenterFlags: getInterfaceFieldValuesFromSection(
      template.monitoringCenterFlags as FormTemplateSection,
      template,
      'monitoringCenterFlags',
      forceInterfaceCreation,
    ),
    ICD: getInterfaceFieldValuesFromSection(
      template.ICD as FormTemplateSection,
      template,
      'ICD',
      forceInterfaceCreation,
    ),
    networkType: getInterfaceFieldValuesFromSection(
      template.networkType as FormTemplateSection,
      template,
      'networkType',
      forceInterfaceCreation,
    ),
    callContentType: getInterfaceFieldValuesFromSection(
      template.callContentType as FormTemplateSection,
      template,
      'callContentType',
      forceInterfaceCreation,
    ),
    usnbdTargetInformation: getInterfaceFieldValuesFromSection(
      template.usnbdTargetInformation as FormTemplateSection,
      template,
      'usnbdTargetInformation',
      forceInterfaceCreation,
    ),
    usnbdCallContentChannelInformation: getInterfaceFieldValuesFromSection(
      template.usnbdCallContentChannelInformation as FormTemplateSection,
      template,
      'usnbdCallContentChannelInformation',
      forceInterfaceCreation,
    ),
  };

  return omitBy(collectionFunctionForm, isNil) as unknown as types.TargetDeliveryTemplateAccessFunctionFormData;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<types.TargetDeliveryTemplateAccessFunctionFormData> {

  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}

function getInterfaceFieldValuesFromSection(
  templateSection: FormTemplateSection,
  template: FormTemplate,
  interfaceName: TargetTemplateFormSection,
  forceInterfaceCreation = false,
): (types.TargetDeliveryTemplateInterfaceFormData)[] | undefined {

  if (templateSection == null) {
    return;
  }

  let fields: Partial<types.TargetDeliveryTemplateInterfaceFormData> = {
    ...getFieldValuesFromSection(templateSection),
  };

  const templateSectionName = interfaceName;

  if (!forceInterfaceCreation && (template[templateSectionName] as FormTemplateSection).metadata.min === 0) {
    return [];
  }

  fields = {
    ...fields,
    ...getFieldValuesFromSection(template[templateSectionName] as FormTemplateSection),
    id: `${nextId}.${types.TARGET_DELIVERY_TEMPLATE_TEMPORARY_ID}`,
  };

  nextId += 1;

  return [fields as types.TargetDeliveryTemplateInterfaceFormData];
}
